import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, debounceTime, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_PERMISSIONS_TOGGLE_FETCH = 'TRN_PERMISSIONS_TOGGLE_FETCH'
export const TRN_PERMISSIONS_TOGGLE_FETCH_CANCELED = 'TRN_PERMISSIONS_TOGGLE_FETCH_CANCELED'
export const TRN_PERMISSIONS_TOGGLE_FETCH_ERROR = 'TRN_PERMISSIONS_TOGGLE_FETCH_ERROR'
export const TRN_PERMISSIONS_TOGGLE_FETCH_FULFILLED = 'TRN_PERMISSIONS_TOGGLE_FETCH_FULFILLED'

export const permissionsToggleFetch = (entityId, authId) => ({
  payload: { authId, entityId },
  type: TRN_PERMISSIONS_TOGGLE_FETCH,
})

export const permissionsToggleFetchFulfilled = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_TOGGLE_FETCH_FULFILLED,
})

export const permissionsToggleFetchCanceled = () => ({
  payload: null,
  type: TRN_PERMISSIONS_TOGGLE_FETCH_CANCELED,
})

export const permissionsToggleFetchError = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_TOGGLE_FETCH_ERROR,
})

export const permissionsToggleFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_PERMISSIONS_TOGGLE_FETCH),
    debounceTime(2000), // wait for 2 seconds before change your main
    mergeMap((action) =>
      epicServerRequest(
        'delete',
        `${APP.api_url}/permissions/${action.payload.entityId}/${action.payload.authId}`,
        action,
      ).pipe(
        map(epicResponseHandler(permissionsToggleFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_PERMISSIONS_TOGGLE_FETCH, TRN_PERMISSIONS_TOGGLE_FETCH_CANCELED))),
        catchError(epicErrorHandler(permissionsToggleFetchError, action)),
      ),
    ),
  )
